import { inputLabelClasses } from '@mui/material/InputLabel';
export var createMuiInputLabelOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, tokens = _a.tokens;
    return {
        defaultProps: {
            shrink: true,
            variant: 'outlined',
        },
        styleOverrides: {
            formControl: {
                position: 'static',
            },
            outlined: (_b = {
                    marginBottom: spacing(1)
                },
                _b["&.".concat(inputLabelClasses.shrink)] = {
                    transform: 'none',
                },
                _b),
            asterisk: {
                color: tokens.color_fg_state_danger,
            },
        },
    };
};
